module.exports = __webpack_public_path__ + "static/media/country_gn.e3195cab.webp";